













// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StoryUser } from '../StoryUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { RawLocation } from 'vue-router';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { globalUC } from '../UserCache';

@Component({
  name: 'PhoneNumberFormComponent',
  components: { 
    VuePhoneNumberInput: () => import('vue-phone-number-input')
   }
})
export default class PhoneNumberFormComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: 'Cancel' })
  public cancelBtnText: string

  @Prop({ default: 'Add' })
  public okBtnText: string

  @Prop({ default: true })
  public alertOrToastWhenDone: boolean

  @Prop({ default: true })
  public allowCancel: boolean

  // public reactive member variables available to the html template
  public phone: string = null;
  public fullPhoneNumber: string = null;
  public phoneNumberIsValid: boolean = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get isAuthenticated(): StoryUser { return this.$store.getters.isAuthenticated }
  public get userId(): StoryUser { return this.$store.getters.userId }

  public clearFields() {
    this.phone = null;
  }
  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }

  // Parents call this to show modal (use a ref to call child -- https://stackoverflow.com/questions/42632711/how-to-call-function-on-child-component-on-parent-events)
  public async onShow(dynamicProps: { phone: string }) {
    if (!dynamicProps) return
    this.phone = dynamicProps.phone
  }

  // onPhoneInput and onPhoneValidate are fired from events emitted from vue-tel-input
  // public onPhoneInput(s: string, o: any) {
  //   this.fullPhoneNumber = o.number.e164
  //   this.phoneNumberIsValid = o.valid
  // }
  // public onPhoneValidate(o: any) {
  //   this.fullPhoneNumber = o.number.e164
  //   this.phoneNumberIsValid = o.valid
  // }

  public onPhoneUpdate(o: any) {
    this.fullPhoneNumber = o.e164
    this.phoneNumberIsValid = o.isValid
  }
  public async onOK() {

    // tidy up form fields

    // validate form fields
    let abort: boolean = false
    if (!this.fullPhoneNumber) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter a phone number.')
    } else if (!this.phoneNumberIsValid) {
      abort = true
      utils.toast(this, 'Invalid phone #', 'Your phone number is invalid.')
    }

    if (abort) return

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/users/' + this.userId
      const response: any = await utils.makePutCall(url, { command: 'addPhoneNumber', fullPhoneNumber: this.fullPhoneNumber } );
      if (!response || !response.data) throw(new Error('PhoneNumberFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user) {
        // success
        if (this.alertOrToastWhenDone) utils.toast(this, 'Success', 'Phone number added')
        const updatedUser: StoryUser = new StoryUser(response.data.user)
        updatedUser.updateMeToCacheStoreAndLocalStorage()
        this.$emit('close', true)

        // clear out in case they do another
        this.clearFields()
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not add phone number')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }


  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private mounted(): void {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    // TODO: get current phone number so we can show it somehwhere
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
